
(function() {
    document.addEventListener("DOMContentLoaded", function () {
        const articleContent = document.querySelector('.article-template__content');
        
        if(articleContent) {
            document.querySelectorAll("p").forEach(p => {
              const content = p.innerHTML.trim();
              if (content === '&nbsp;' || content === '\u00A0') {
                p.classList.add("only-nbsp");
              }
            });

            document.querySelectorAll("ul").forEach(ul => {
                const prev = ul.previousElementSibling;
                if (prev && prev.tagName === "H4") {
                    prev.classList.add("h4-before-ul");
                }
            });
        }
    });


    const articleNav = () => {
        const article = document.querySelector('#post-content');
        const tocList = document.querySelector('#tocList');
        if (!article || !tocList) return;

        // 1) Detectar altura del header fijo
        const header = document.querySelector('header.header-main') /* <-- CAMBIA ESTE SELECTOR */
                    || document.querySelector('header[data-fixed]') 
                    || null;

        let headerHeight = 0;
        const updateHeaderHeight = () => {
            headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        };
        updateHeaderHeight();
        window.addEventListener('resize', updateHeaderHeight);

        // 2) Generar TOC (H2/H3) — igual que antes
        const headings = [...article.querySelectorAll('h2')];
        if (!headings.length) return;

        const slugCounts = new Map();
        const slugify = (t) => {
            const base = t.toLowerCase()
            .normalize('NFD').replace(/\p{Diacritic}/gu,'')
            .replace(/[^\w\s-]/g,'').trim().replace(/\s+/g,'-');
            const n = slugCounts.get(base) || 0; slugCounts.set(base, n+1);
            return n ? `${base}-${n}` : base;
        };
        const ensureId = (el) => (el.id ||= slugify(el.textContent || 'seccion'));

        let currentUl = tocList, lastLevel = 2;
        headings.forEach(h => {
            const level = Number(h.tagName.slice(1));
            const id = ensureId(h);
            if (level > lastLevel) {
            const sub = document.createElement('ul');
            currentUl.lastElementChild?.appendChild(sub);
            currentUl = sub;
            } else if (level < lastLevel) {
            currentUl = currentUl.parentElement.closest('ul') || tocList;
            }
            lastLevel = level;
            const li = document.createElement('li');
            const a = Object.assign(document.createElement('a'), {
            href: `#${id}`, textContent: h.textContent.trim(), className: 'toc__link'
            });
            li.appendChild(a); currentUl.appendChild(li);
        });

        // 3) Scroll suave con OFFSET del header
        const smoothScrollTo = (el) => {
            const y = el.getBoundingClientRect().top + window.scrollY - (headerHeight + 8);
            window.scrollTo({ top: y, behavior: 'smooth' });
        };
        tocList.addEventListener('click', (e) => {
            const a = e.target.closest('a[href^="#"]'); if (!a) return;
            e.preventDefault();
            const target = document.querySelector(a.getAttribute('href'));
            if (!target) return;
            smoothScrollTo(target);
            history.pushState(null, '', a.getAttribute('href'));
        });

        // 4) Resaltar activo con IntersectionObserver (ajustado al header)
        const linkMap = new Map();
        tocList.querySelectorAll('a[href^="#"]').forEach(a => {
            linkMap.set(a.getAttribute('href').slice(1), a);
        });
        const setActive = (id) => {
            tocList.querySelectorAll('.toc__link--active').forEach(n => n.classList.remove('toc__link--active'));
            const a = linkMap.get(id); if (a) a.classList.add('toc__link--active');
        };

        const ioOpts = () => ({
            // desplazamos el umbral superior por la altura del header
            root: null,
            rootMargin: `-${headerHeight + 10}px 0px -60% 0px`,
            threshold: [0, 0.25, 0.5, 1]
        });

        let io = new IntersectionObserver((entries) => {
            const visible = entries
            .filter(en => en.isIntersecting)
            .sort((a,b) => Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top));
            if (visible[0]) setActive(visible[0].target.id);
            else {
            const passed = headings.filter(h => h.getBoundingClientRect().top <= (headerHeight + 10));
            if (passed.length) setActive(passed[passed.length - 1].id);
            }
        }, ioOpts());

        headings.forEach(h => io.observe(h));

        // Re-crear el observer si cambia la altura del header (por responsive)
        const ro = new ResizeObserver(() => {
            const prev = headerHeight;
            updateHeaderHeight();
            if (headerHeight !== prev) {
            io.disconnect();
            io = new IntersectionObserver(io.takeRecords && ioOpts() || ioOpts()); // reconstruir con nuevos márgenes
            headings.forEach(h => io.observe(h));
            }
        });
        if (header) ro.observe(header);

        // Si se entra con hash, corrige la posición inicial
        if (location.hash) {
            const target = document.getElementById(location.hash.slice(1));
            if (target) setTimeout(() => smoothScrollTo(target), 0);
        }
    }
    articleNav();

})();